import type { Dictionary } from '@emobg/web-utils';

import type { DocumentType, Gender } from '@store/Steps/types';

export const DOCUMENT_TYPE = {
  nif: 'NIF',
  passport: 'PASSPORT',
  drivingLicense: 'DRIVERLICENSE',
  onfido: {
    nif: 'national_identity_card',
    passport: 'passport',
    drivingLicense: 'driving_licence',
  },
} as const;

export const DOCUMENTS = {
  [DOCUMENT_TYPE.nif]: DOCUMENT_TYPE.onfido.nif,
  [DOCUMENT_TYPE.onfido.nif]: DOCUMENT_TYPE.nif,
  [DOCUMENT_TYPE.passport]: DOCUMENT_TYPE.onfido.passport,
  [DOCUMENT_TYPE.onfido.passport]: DOCUMENT_TYPE.passport,
  [DOCUMENT_TYPE.drivingLicense]: DOCUMENT_TYPE.onfido.drivingLicense,
  [DOCUMENT_TYPE.onfido.drivingLicense]: DOCUMENT_TYPE.drivingLicense,
} as const;

export const DOCUMENTS_TRANSLATIONS_KEYS = {
  [DOCUMENT_TYPE.nif]: 'requiredDocuments.nationalId',
  [DOCUMENT_TYPE.passport]: 'requiredDocuments.passport',
  [DOCUMENT_TYPE.drivingLicense]: 'requiredDocuments.drivinglicense',
} as const;

export const AUTOFILL_DOCUMENT_TYPES = {
  nif: DOCUMENTS_TRANSLATIONS_KEYS[DOCUMENT_TYPE.nif],
  driverLicense: DOCUMENTS_TRANSLATIONS_KEYS[DOCUMENT_TYPE.drivingLicense],
  passport: DOCUMENTS_TRANSLATIONS_KEYS[DOCUMENT_TYPE.passport],
} as const;

export const AUTOFILL_MISSING_DATA_TRANSLATIONS = {
  firstName: 'missingData.firstName',
  lastName: 'missingData.lastName',
  dateOfBirth: 'missingData.dateOfBirth',
  documentNumber: 'missingData.documentNumber',
  gender: 'missingData.gender',
  issuingDate: 'missingData.issuingDate',
  expiryDate: 'missingData.expiryDate',
  addressLine1: 'missingData.primaryAddressLine',
  addressLine2: 'missingData.secondaryAddressLine',
  issuingCountry: 'missingData.issuingCountry',
  issuingState: 'missingData.issuingProvince',
} as const;

export const AUTOFILL_DOCUMENTS: Dictionary<DocumentType> = {
  nif: 'nif',
  passport: 'passport',
  driverLicense: 'driverLicense',
} as const;

export const MISSING_DATA_TYPES = {
  gender: 'gender',
} as const;

export const GENDERS: Dictionary<Gender> = {
  male: 'male',
  female: 'female',
  other: 'other',
} as const;
